// This does not really belong here but putting it here is the easier way to solve dep cruiser errors
// TODO: move this to a more appropriate place
export const SCHEMA_COLUMN_PREFIX = 'field';
